import React, { useEffect, useState } from "react";
import "./CatagoryPreview.scss";
import ProductCard from "../ProductCard/ProductCard";
import Button from "../Button/Button";
import { withRouter } from "react-router";
import { GetProducts } from "../../api/products.api";
import { CircularProgress } from "@material-ui/core";

const CatagoryPreview = ({ title, history }) => {
  const [data, setData] = useState([]);
  const [showLoading, setShowLoading] = useState(true);

  useEffect(() => {
    const getData = async () => {
      setShowLoading(true);
      const products = await GetProducts(title.toLowerCase());
      setData(products);
      setShowLoading(false);
    };
    getData();
  }, []);

  return (
    <div className="CatagoryPreview">
      <h2 className="h2">{title}</h2>

      <Button
        onClick={() => history.push(`/products/${title.toLowerCase()}`)}
        text="View All"
        width="150px"
      />

      <div className="content">
        {!showLoading ? (
          data
            .filter((item, idx) => idx < 4)
            .map((product) => <ProductCard data={product} />)
        ) : (
          <CircularProgress
            style={{ color: "black", margin: "auto" }}
            size={50}
          />
        )}
      </div>
    </div>
  );
};

export default withRouter(CatagoryPreview);
